import { cn } from "@/utils/utils";

/**
 * An indeterminate progress ring.
 *
 * Two arcs on one circle — a faint track and a solid head — so the motion
 * reads even at 14px, where a dashed spinner turns to mush. It is decorative;
 * whatever is loading announces itself through `aria-busy` on its own region.
 */
export function Spinner({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      aria-hidden
      className={cn("size-4 animate-spin", className)}
    >
      <circle
        cx="10"
        cy="10"
        r="8"
        stroke="currentColor"
        strokeOpacity="0.25"
        strokeWidth="2.5"
      />
      <path
        d="M18 10a8 8 0 0 0-8-8"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
